let markers: google.maps.Marker[] = [];
export class CustomMap {
  public googlemap: google.maps.Map;

  constructor(divID: string) {
    this.googlemap = new google.maps.Map(document.getElementById(divID), {
      zoom: 5,
      center: {
        lat: -25,
        lng: 135,
      },
    });
  }

  addMarker(
    obj: google.maps.LatLng,
    counting: number,
    optionalContentString = 'defaultValue'
  ): void {
    // var gmarker: google.maps.Marker[] = [];
    counting--;
    const marker = new google.maps.Marker({
      map: this.googlemap,
      position: obj,
    });

    const infowindow = new google.maps.InfoWindow({
      content: optionalContentString,
    });

    marker.addListener('click', () => {
      infowindow.open(this.googlemap, marker);
    });
    markers.push(marker);
    // this.setMarkers(gmarker);
  }

  removeMarkers(gmarkers: google.maps.Marker[]): void {
    for (let i = 0; i < gmarkers.length; i++) {
      gmarkers[i].setMap(null);
    }
  }

  autoComplete(): google.maps.LatLng {
    const input = document.getElementById(
      'autocompleteplaces'
    ) as HTMLInputElement;
    const optimising = document.getElementById(
      'optimising'
    ) as HTMLButtonElement;
    const search = document.getElementById('Search');
    var bounds = new google.maps.LatLngBounds();
    const options = {
      types: ['address'],
      componentRestrictions: { country: 'aus' },
      fields: ['formatted_address', 'geometry', 'name'],
    };

    const autocompleteplaces = new google.maps.places.Autocomplete(
      input,
      options
    );
    const marker = new google.maps.Marker({
      map: this.googlemap,
      anchorPoint: new google.maps.Point(0, -29),
    });

    this.googlemap.controls[google.maps.ControlPosition.TOP_RIGHT].push(search);

    autocompleteplaces.setTypes(['address']);

    autocompleteplaces.addListener('place_changed', () => {
      const place = autocompleteplaces.getPlace();
      const add = document.getElementById('add') as HTMLButtonElement;
      if (!place.geometry || !place.geometry.location) {
        // User entered the name of a Place that was not suggested and
        // pressed the Enter key, or the Place Details request failed.
        window.alert("No details available for input: '" + place.name + "'");
        return;
      }

      // If the place has a geometry, then present it on a map.
      if (place.geometry.viewport) {
        this.googlemap.fitBounds(place.geometry.viewport);
      } else {
        this.googlemap.setCenter(place.geometry.location);
        this.googlemap.setZoom(17);
      }

      marker.setPosition(place.geometry.location);

      marker.setVisible(true);
      const contentString = place.formatted_address;
      add.addEventListener('click', () => {
        bounds.extend(marker.getPosition());

        //  this.addMarker(marker.getPosition(), contentString);
      });

      optimising.addEventListener('click', () => {
        this.googlemap.setCenter(bounds.getCenter());
        this.googlemap.fitBounds(bounds);
      });

      add.disabled = false;
    });
    return marker.getPosition();
  }

  gettingPlaces(): Array<string> {
    const input = document.getElementById(
      'autocompleteplaces'
    ) as HTMLInputElement;
    const add = document.getElementById('add') as HTMLButtonElement;
    const directionsService = new google.maps.DirectionsService();
    const directionsRenderer = new google.maps.DirectionsRenderer();
    const list: Array<string> = new Array(10);
    const listItems = document.getElementById('listItems') as HTMLDivElement;
    const optimising = document.getElementById(
      'optimising'
    ) as HTMLButtonElement;

    const listItemsText = document.getElementById(
      'listItemsText'
    ) as HTMLParagraphElement;

    add.addEventListener('click', () => {
      if (this.checkDuplicate(list, input.value) === false) {
        if (this.isBlank(input.value) !== true) {
          for (let i = 0; i < list.length; i++) {
            if (this.isBlank(list[i]) === true) {
              list[i] = input.value;

              add.disabled = true;

              let node = document.createElement('li');

              let textNode = document.createTextNode(list[i]);

              node.appendChild(textNode);

              listItems.appendChild(node);

              listItemsText.innerHTML = 'Start from here';

              optimising.disabled = false;

              input.value = '';

              break;
            }
          }
        } else {
          alert('Empty value. Please enter location');
        }
      } else {
        alert('Already added');
      }
    });

    optimising.addEventListener('click', () => {
      if (list[1] === undefined) {
        alert('Please enter at least 2 addresses');
      } else {
        document
          .getElementById('listOfPlaces')
          .setAttribute(
            'style',
            'opacity:0.5; -moz-opacity:0.5; filter:alpha(opacity=50)'
          );
      }
      this.hideMarkers();
      this.CalculateAndDisplayRoute(
        directionsService,
        directionsRenderer,
        list
      );
    });

    return list;
  }
  isBlank(str): boolean {
    return !str || /^\s*$/.test(str);
  }

  checkDuplicate(arr: Array<string>, input: string): boolean {
    let result: boolean;
    for (let i = 0; i < arr.length; i++) {
      if (input === arr[i]) {
        result = true;
        break;
      } else {
        result = false;
      }
    }

    return result;
  }

  convertAddressesToPosition(list: Array<string>): string[] {
    var geocoder = new google.maps.Geocoder();

    let markers: Array<string | number> = new Array(10);
    for (let i = 0; i < list.length; i++) {
      if (list[i] !== undefined) {
        geocoder.geocode({ address: list[i] }, (results, status) => {
          if (status == google.maps.GeocoderStatus.OK) {
            var latitude = results[0].geometry.location.lat();
            var longitude = results[0].geometry.location.lng();
            markers[i] = latitude + ',' + longitude;
            // alert(markers[i]);
            // alert(results[0].geometry.location);
          }
        });
      }
    }

    return list;
  }
  getLatLngFromString(list): google.maps.LatLng {
    let latlng = list.split(',');
    return new google.maps.LatLng(parseFloat(latlng[0]), parseFloat(latlng[1]));
  }

  CalculateAndDisplayRoute(
    directionsService: google.maps.DirectionsService,
    directionsRenderer: google.maps.DirectionsRenderer,
    list: Array<string>
  ) {
    const waypts: google.maps.DirectionsWaypoint[] = [];
    const checkboxArray = list;
    let a = 0;
    for (let i = 0; i < checkboxArray.length; i++) {
      if (checkboxArray[i] !== undefined) {
        waypts.push({
          location: checkboxArray[i],
          stopover: true,
        });

        a = i;
      }
    }
    console.log('list: ' + list);
    for (let i = 0; i < waypts.length; i++) {
      console.log('waypts ' + i + ': ' + waypts[i].location);
    }

    directionsService.route(
      {
        origin: list[0],
        destination: list[a],
        travelMode: google.maps.TravelMode.DRIVING,

        waypoints: waypts,
      },
      (response, status) => {
        directionsRenderer.setMap(this.googlemap);
        directionsRenderer.setDirections(response);

        const route = response.routes[0];
        const summaryPanel = document.getElementById(
          'directions-panel'
        ) as HTMLElement;
        console.log(route.legs.length);
        if (route.legs.length > 4) {
          // const remove1stRoute = route.legs.shift();
          const removeLastRoute = route.legs.pop();
        } else if (route.legs.length <= 4) {
          // const remove1stRoute = route.legs.shift();
          const removeLastRoute = route.legs.pop();
        }

        let counting = 1;
        summaryPanel.innerHTML = '';

        // this.addMarker(
        //   route.legs[0].start_location,

        //   route.legs[0].start_address
        // );

        // A,B B,C, C,D D,E
        for (let i = 0; i < route.legs.length; i++) {
          if (i !== 0 || i === route.legs.length) {
            if (i === 1) {
              summaryPanel.innerHTML += '<b>Start from here: ' + '</b><br>';
            }
            if (i === route.legs.length - 1) {
              summaryPanel.innerHTML += '<b>End at here: ' + '</b><br>';
            }
            summaryPanel.innerHTML +=
              '-------------------------------------------' +
              '<p style="color: blue">' +
              route.legs[i].start_address +
              '</p>' +
              ' ----> ';
            summaryPanel.innerHTML +=
              '<p style="color: red">' +
              route.legs[i].end_address +
              '</p>' +
              '<br>';
            summaryPanel.innerHTML +=
              'Distance: ' + route.legs[i].distance!.text + '<br><br>';
          }
        }
        // start marker
        this.addMarker(route.legs[0].start_location, counting++);
        // the rest
        for (var i = 0; i < route.legs.length; i++) {
          this.addMarker(route.legs[i].end_location, counting++);
        }
        for (let i = 0; i < route.legs.length; i++) {
          console.log('Route' + i + ': ' + route.legs[i].start_address);
        }
      }
    );
  }
  // Removes the markers from the map, but keeps them in the array.
  hideMarkers(): void {
    this.setMapOnAll(null);
  }

  // Shows any markers currently in the array.
  showMarkers(): void {
    this.setMapOnAll(this.googlemap);
  }
  // Sets the map on all markers in the array.
  setMapOnAll(map: google.maps.Map | null) {
    for (let i = 0; i < markers.length; i++) {
      markers[i].setMap(map);
    }
  }
}
